export const coteachersHelpArticleUrl =
  'https://help.albert.io/en/articles/2459978-co-teacher-classrooms';
